import { /* createAction, */createReducer } from 'redux-act';
// import Immutable from 'seamless-immutable'
// import moment from 'moment'

export var key = 'SubmitSchool';

//
// Initial state
//
var initialState = {};

//
// Actions
//
export var actions = {};

//
// Reducer
//
export var reducer = createReducer({}, initialState);

//
// Selectors
//

// const root = (state) => state[key]

export var selectors = {};